const dashboardDataConfig = [
    {
        dashboardName: "Hitachi Overall Dashboard",
        data: {
            labels: ["Hitachi"],
            datasets: [
                {
                    label: "Basic",
                    data: [0],
                    backgroundColor: "#E1ECFB",
                },
                {
                    label: "Developing",
                    data: [0],
                    backgroundColor: "#C7DFFF",
                },
                {
                    label: "Mature",
                    data: [0],
                    backgroundColor: "#4CA1E6",
                },
                {
                    label: "Aggregate",
                    data: [0],
                    backgroundColor: "#024B86",
                },
            ],
        },
        options: {
            responsive: true,
            plugins: {
                legend: {
                    position: "bottom",
                },
                title: {
                    display: true,
                    font: {
                        size: 20,
                    },
                    text: "Hitachi Overall Dashboard",
                },
            },
            scales: {
                x: {
                    stacked: true,
                    display: false,
                },
                y: {
                    stacked: true,
                },
            },
        },
        primaryFilters: [
            {
                name: "Slot",
                isMultiSelect: false,
            },
            {
                name: "Template",
                isMultiSelect: false,
            },
        ],
    },
    {
        dashboardName: "Sector Dashboard",
        data: {
            labels: ["Hitachi", "Sector 3", "Sector 2", "Sector 1"],
            datasets: [
                {
                    label: "Basic",
                    data: [0, 0, 0, 0],
                    backgroundColor: "#E1ECFB",
                },
                {
                    label: "Developing",
                    data: [0, 0, 0, 0],
                    backgroundColor: "#C7DFFF",
                },
                {
                    label: "Mature",
                    data: [0, 0, 0, 0],
                    backgroundColor: "#4CA1E6",
                },
                {
                    label: "Aggregate",
                    data: [0, 0, 0, 0],
                    backgroundColor: "#024B86",
                },
            ],
        },
        options: {
            responsive: true,
            plugins: {
                legend: {
                    position: "bottom",
                },
                title: {
                    display: true,
                    font: {
                        size: 20,
                    },
                    text: "Sector Dashboard",
                },
            },
            scales: {
                x: {
                    stacked: true,
                    display: false,
                },
                y: {
                    stacked: true,
                },
            },
        },
        primaryFilters: [
            { name: "Slot", isMultiSelect: false },
            { name: "Template", isMultiSelect: false },
            { name: "Sector", isMultiSelect: true },
        ],
        secondaryFilters: [
            { name: "Region", isMultiSelect: false },
            { name: "Country", isMultiSelect: false },
        ],
    },
    {
        dashboardName: "Business Unit Dashboard",
        data: {
            labels: [
                "Hitachi",
                "Business Unit 3",
                "Business Unit 2",
                "Business Unit 1",
            ],
            datasets: [
                {
                    label: "Basic",
                    data: [0, 0, 0, 0],
                    backgroundColor: "#E1ECFB",
                },
                {
                    label: "Developing",
                    data: [0, 0, 0, 0],
                    backgroundColor: "#C7DFFF",
                },
                {
                    label: "Mature",
                    data: [0, 0, 0, 0],
                    backgroundColor: "#4CA1E6",
                },
                {
                    label: "Aggregate",
                    data: [0, 0, 0, 0],
                    backgroundColor: "#024B86",
                },
            ],
        },
        options: {
            responsive: true,
            plugins: {
                legend: {
                    position: "bottom",
                },
                title: {
                    display: true,
                    font: {
                        size: 20,
                    },
                    text: "Business Unit Dashboard",
                },
            },
            scales: {
                x: {
                    stacked: true,
                    display: false,
                },
                y: {
                    stacked: true,
                },
            },
        },
        primaryFilters: [
            { name: "Slot", isMultiSelect: false },
            { name: "Template", isMultiSelect: false },
            { name: "Sector", isMultiSelect: false },
            { name: "Business Unit", isMultiSelect: true },
        ],
        secondaryFilters: [
            { name: "Region", isMultiSelect: false },
            { name: "Country", isMultiSelect: false },
        ],
    },
    {
        dashboardName: "Sub Business Unit Dashboard",
        data: {
            labels: ["Hitachi", "Sub BU 3", "Sub BU 2", "Sub BU 1"],
            datasets: [
                {
                    label: "Basic",
                    data: [0, 0, 0, 0],
                    backgroundColor: "#E1ECFB",
                },
                {
                    label: "Developing",
                    data: [0, 0, 0, 0],
                    backgroundColor: "#C7DFFF",
                },
                {
                    label: "Mature",
                    data: [0, 0, 0, 0],
                    backgroundColor: "#4CA1E6",
                },
                {
                    label: "Aggregate",
                    data: [0, 0, 0, 0],
                    backgroundColor: "#024B86",
                },
            ],
        },
        options: {
            responsive: true,
            plugins: {
                legend: {
                    position: "bottom",
                },
                title: {
                    display: true,
                    font: {
                        size: 20,
                    },
                    text: "Sub Business Unit Dashboard",
                },
            },
            scales: {
                x: {
                    stacked: true,
                    display: false,
                },
                y: {
                    stacked: true,
                },
            },
        },
        primaryFilters: [
            { name: "Slot", isMultiSelect: false },
            { name: "Template", isMultiSelect: false },
            { name: "Sector", isMultiSelect: false },
            { name: "Business Unit", isMultiSelect: false },
            { name: "Sub BU", isMultiSelect: true },
        ],
        secondaryFilters: [
            { name: "Region", isMultiSelect: false },
            { name: "Country", isMultiSelect: false },
        ],
    },
    {
        dashboardName: "Entity Dashboard",
        data: {
            labels: [
                "Hitachi",
                "Legal Entity 3",
                "Legal Entity 2",
                "Legal Entity 1",
            ],
            datasets: [
                {
                    label: "Basic",
                    data: [0, 0, 0, 0],
                    backgroundColor: "#E1ECFB",
                },
                {
                    label: "Developing",
                    data: [0, 0, 0, 0],
                    backgroundColor: "#C7DFFF",
                },
                {
                    label: "Mature",
                    data: [0, 0, 0, 0],
                    backgroundColor: "#4CA1E6",
                },
                {
                    label: "Aggregate",
                    data: [0, 0, 0, 0],
                    backgroundColor: "#024B86",
                },
            ],
        },
        options: {
            responsive: true,
            plugins: {
                legend: {
                    position: "bottom",
                },
                title: {
                    display: true,
                    font: {
                        size: 20,
                    },
                    text: "Entity Dashboard",
                },
            },
            scales: {
                x: {
                    stacked: true,
                    display: false,
                },
                y: {
                    stacked: true,
                },
            },
        },
        primaryFilters: [
            { name: "Slot", isMultiSelect: false },
            { name: "Template", isMultiSelect: false },
            { name: "Sector", isMultiSelect: false },
            { name: "Business Unit", isMultiSelect: false },
            { name: "Sub BU", isMultiSelect: false },
            { name: "Entity", isMultiSelect: true },
        ],
        secondaryFilters: [
            { name: "Region", isMultiSelect: false },
            { name: "Country", isMultiSelect: false },
        ],
    },
    {
        dashboardName: "Region Dashboard",
        data: {
            labels: ["Hitachi", "Region 3", "Region 2", "Region 1"],
            datasets: [
                {
                    label: "Basic",
                    data: [0, 0, 0, 0],
                    backgroundColor: "#E1ECFB",
                },
                {
                    label: "Developing",
                    data: [0, 0, 0, 0],
                    backgroundColor: "#C7DFFF",
                },
                {
                    label: "Mature",
                    data: [0, 0, 0, 0],
                    backgroundColor: "#4CA1E6",
                },
                {
                    label: "Aggregate",
                    data: [0, 0, 0, 0],
                    backgroundColor: "#024B86",
                },
            ],
        },
        options: {
            responsive: true,
            plugins: {
                legend: {
                    position: "bottom",
                },
                title: {
                    display: true,
                    font: {
                        size: 20,
                    },
                    text: "Region Dashboard",
                },
            },
            scales: {
                x: {
                    stacked: true,
                    display: false,
                },
                y: {
                    stacked: true,
                },
            },
        },
        primaryFilters: [
            { name: "Slot", isMultiSelect: false },
            { name: "Template", isMultiSelect: false },
            { name: "Region", isMultiSelect: true },
        ],
        secondaryFilters: [
            { name: "Sector", isMultiSelect: false },
            { name: "Business Unit", isMultiSelect: false },
            { name: "Sub BU", isMultiSelect: false },
            { name: "Entity", isMultiSelect: false },
        ],
    },
    {
        dashboardName: "Country Dashboard",
        data: {
            labels: ["Hitachi", "Country 3", "Country 2", "Country 1"],
            datasets: [
                {
                    label: "Basic",
                    data: [0, 0, 0, 0],
                    backgroundColor: "#E1ECFB",
                },
                {
                    label: "Developing",
                    data: [0, 0, 0, 0],
                    backgroundColor: "#C7DFFF",
                },
                {
                    label: "Mature",
                    data: [0, 0, 0, 0],
                    backgroundColor: "#4CA1E6",
                },
                {
                    label: "Aggregate",
                    data: [0, 0, 0, 0],
                    backgroundColor: "#024B86",
                },
            ],
        },
        options: {
            responsive: true,
            plugins: {
                legend: {
                    position: "bottom",
                },
                title: {
                    display: true,
                    font: {
                        size: 20,
                    },
                    text: "Country Dashboard",
                },
            },
            scales: {
                x: {
                    stacked: true,
                    display: false,
                },
                y: {
                    stacked: true,
                },
            },
        },
        primaryFilters: [
            { name: "Slot", isMultiSelect: false },
            { name: "Template", isMultiSelect: false },
            { name: "Region", isMultiSelect: false },
            { name: "Country", isMultiSelect: true },
        ],
        secondaryFilters: [
            { name: "Sector", isMultiSelect: false },
            { name: "Business Unit", isMultiSelect: false },
            { name: "Sub BU", isMultiSelect: false },
            { name: "Entity", isMultiSelect: false },
        ],
    },
];

export default dashboardDataConfig;
